// extracted by mini-css-extract-plugin
export default {"row":"O4YcTFaE8uDoxgKacFC9"};